<div class="container-fluid py-4">
  <div class="row mb-4 justify-content-center">
    <div class="col-3 col-md-2" *ngFor="let card of resumenCards; index as i">
      <!-- <div
          [class]="i < 3 ? 'col-md-4' : 'col-md-3'"
          *ngFor="let card of resumenCards; index as i"
        > -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 1 }"
        [routerLink]="card.route"
        [style.cursor]="card.route || i === 0 || 1 ? 'pointer' : 'default'"
      >
        <!-- (click)="i === 0 ? getInternal() : null" 
             (click)="handleCardClick(i)"-->
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow icon-card"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 1, 'text-white': i !== 1 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 1 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-6 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <a class="btn btn-dark btn-sm btn-refresh" (click)="getData()">
        <i class="fa-solid fa-arrow-rotate-right"></i>
      </a>

      <div class="flex-grow-1 text-center">
        <a class="btn btn-dark btn-sm btn-step" (click)="changeStep(1)">
          Campaigns
        </a>
        <a class="btn btn-dark btn-sm btn-step" (click)="changeStep(2)"> Groups </a>
        <a class="btn btn-dark btn-sm btn-step" (click)="changeStep(3)"> Keywords </a>
        <a class="btn btn-dark btn-sm btn-step" (click)="changeStep(4)"> Metrics </a>
      </div>

      <div style="width: 40px"></div>
    </div>
  </div>

  <!-- Campañas -->
  <h2 *ngIf="step == 1">Campaigns</h2>

  <div class="card shadow-sm" *ngIf="step == 1">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Id</th>
              <th>Name</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of campaigns">
              <td>
                {{ item.campaign.id }}
              </td>
              <td>{{ item.campaign.name }}</td>
              <td>{{ item.campaign.status }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Grupos -->
  <h2 *ngIf="step == 2">Groups</h2>

  <div class="card shadow-sm" *ngIf="step == 2">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Id</th>
              <th>Name</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of groups">
              <td>
                {{ item.ad_group.id }}
              </td>
              <td>{{ item.ad_group.name }}</td>
              <td>{{ item.ad_group.status }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- keywords -->
  <h2 *ngIf="step == 3">Keywords</h2>

  <div class="card shadow-sm" *ngIf="step == 3">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Name</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of keywords">
              <td>{{ item.ad_group_criterion.keyword.text }}</td>
              <td>{{ item.ad_group_criterion.status }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- metrics -->
  <h2 *ngIf="step == 4">Metrics</h2>

  <div class="card shadow-sm" *ngIf="step == 4">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Campaña</th>
              <th>Clicks</th>
              <th>Conversions</th>
              <th>Cost_micros</th>
              <th>Impressions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of metrics">
              <td>
                {{ item.campaign.name }}
              </td>
              <td>{{ item.metrics.clicks }}</td>
              <td>{{ item.metrics.conversions }}</td>
              <td>{{ item.metrics.cost_micros }}</td>
              <td>{{ item.metrics.impressions }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
